import * as React from 'react';

export const hkFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3137)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#EA1A1A'
            />
            <mask
                id='mask0_55_3137'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3137)'>
                <path
                    d='M15.4209 10.2012C15.4209 10.2012 21.1477 11.8396 17.3076 16C17.3076 16 15.1809 15.1478 15.4209 13.0186C15.661 10.8893 16.1065 10.4304 15.4209 10.2012ZM13.916 11.4785C13.9237 11.5213 14.9209 17.0985 9.33102 15.6826C9.33102 15.6826 9.17788 13.4852 11.2783 12.7383C13.3789 11.9914 14.0078 12.1667 13.916 11.4785ZM7.01169 7.28613C7.01169 7.28613 9.23192 6.69329 10.4277 8.50488C11.6234 10.3163 11.5725 10.94 12.2588 10.7129C12.2588 10.7129 6.70531 12.8256 7.01169 7.28613ZM14.6777 9.67969C14.6777 9.67969 17.49 4.64044 21 9.05859C21 9.05859 19.7057 10.8817 17.5683 10.2363C15.4311 9.59099 15.0484 9.08273 14.6777 9.67969ZM14.458 4C14.458 4 16.0061 5.63198 14.8447 7.46387C13.6832 9.29523 13.0763 9.53062 13.5957 10.0156C13.5658 9.99011 9.15304 6.20716 14.458 4Z'
                    fill='white'
                />
                <path
                    d='M9.03516 9.10813L9.36032 8.91074C10.0741 9.98396 11.0004 10.512 12.1564 10.512V10.8801C10.8631 10.8801 9.81702 10.2838 9.03516 9.10813Z'
                    fill='#EA1A1A'
                />
                <path
                    d='M18.127 9.40843C18.4461 9.40843 18.7048 9.16124 18.7048 8.85631C18.7048 8.55139 18.4461 8.3042 18.127 8.3042C17.8078 8.3042 17.5491 8.55139 17.5491 8.85631C17.5491 9.16124 17.8078 9.40843 18.127 9.40843Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#EA1A1A'
                />
                <path
                    d='M16.7466 13.0731C17.0658 13.0731 17.3245 12.8259 17.3245 12.521C17.3245 12.216 17.0658 11.9688 16.7466 11.9688C16.4275 11.9688 16.1688 12.216 16.1688 12.521C16.1688 12.8259 16.4275 13.0731 16.7466 13.0731Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#EA1A1A'
                />
                <path
                    d='M12.1236 14.5454C12.4427 14.5454 12.7015 14.2982 12.7015 13.9933C12.7015 13.6884 12.4427 13.4412 12.1236 13.4412C11.8044 13.4412 11.5457 13.6884 11.5457 13.9933C11.5457 14.2982 11.8044 14.5454 12.1236 14.5454Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#EA1A1A'
                />
                <path
                    d='M9.04156 9.39231C9.36072 9.39231 9.61944 9.14512 9.61944 8.8402C9.61944 8.53528 9.36072 8.28809 9.04156 8.28809C8.72241 8.28809 8.46368 8.53528 8.46368 8.8402C8.46368 9.14512 8.72241 9.39231 9.04156 9.39231Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#EA1A1A'
                />
                <path
                    d='M13.6646 7.18382C13.9838 7.18382 14.2425 6.93663 14.2425 6.6317C14.2425 6.32678 13.9838 6.07959 13.6646 6.07959C13.3455 6.07959 13.0867 6.32678 13.0867 6.6317C13.0867 6.93663 13.3455 7.18382 13.6646 7.18382Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#EA1A1A'
                />
                <path
                    d='M13.415 6.68669L13.7537 6.8621C13.1121 7.99282 13.0669 9.03576 13.6101 10.0119L13.27 10.1847C12.6634 9.09472 12.7143 7.92171 13.415 6.68669Z'
                    fill='#EA1A1A'
                />
                <path
                    d='M18.3311 8.62496L18.2734 8.98888C16.7664 8.77061 15.6384 9.07436 14.8661 9.89392L14.5798 9.64763C15.4463 8.72818 16.7045 8.38936 18.3311 8.62496Z'
                    fill='#EA1A1A'
                />
                <path
                    d='M17.0492 12.8057L16.6715 12.8783C16.3708 11.4507 15.6862 10.5419 14.616 10.1288L14.7603 9.78748C15.961 10.251 16.7246 11.2647 17.0492 12.8057Z'
                    fill='#EA1A1A'
                />
                <path
                    d='M12.0835 14.1199L11.8829 13.8056C13.1841 13.0474 13.8439 12.1219 13.8841 11.0198L14.2692 11.0326C14.224 12.2691 13.4881 13.3014 12.0835 14.1199Z'
                    fill='#EA1A1A'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3137'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
